import React from "react";
import Section from "./../Section";
import SectionHeader from "./../SectionHeader";
import "./styles.scss";

function QuizQuestionPreview(props) {
  return (
    <Section color={props.color} size={1}>
      <div className="container">
        <div className="columns">
          <div className="column">
            <figure className="QuizQuestion__image image">
              <img src={props.image} alt="Illustration" />
            </figure>
          </div>
          <div className="column is-three-quarters">
            <SectionHeader title={props.title} size={4} />
            {props.children}
          </div>
        </div>
      </div>
    </Section>
  );
}

export default QuizQuestionPreview;
